import MSDFTextGeometry from "./MSDFTextGeometry/index.js"
// import blender from "./assets/coffeemat.glb?url"
import auraExplosionLoop from "./assets/audio/aura-explosion-loop.mp3?url"
import auraExplosion from "./assets/audio/aura-explosion.mp3?url"
import worksPreAura from "./assets/audio/aura-pre-transformation.mp3?url"
import guestbookSoundtrack from "./assets/audio/guerra_di_piero.mp3?url"
import introSoundtrack from "./assets/audio/intro-soundtrack.mp3?url"
import screaming1 from "./assets/audio/screaming-1.mp3?url"
import screaming2 from "./assets/audio/screaming-2.mp3?url"
import bmfontUbuntuMonoBold from "./assets/fonts/UbuntuMono-Bold.json?url"
import bmfontUbuntuMonoRegular from "./assets/fonts/UbuntuSansMono-Regular.json?url"
import atlasUbuntuMonoBold from "./assets/fonts/ubuntu_mono_bold.png?url"
import atlasUbuntuSansMonoRegular from "./assets/fonts/ubuntu_sans_mono_regular.png?url"
import man from "./assets/man.glb?url"
import blender from "./assets/scene.glb?url"
import fbm from "./textures/fbm.avif?url"
import perlin from "./textures/perlin.avif?url"
import random from "./textures/random.avif?url"

export * from "./Rain"
export * from "./ScrollManager"
export * from "./Sky"
export * from "./Sky3"
export * from "./components"
export * from "./hooks"
export * from "./shaders"
export * from "./utils/contactLinks"
export * from "./utils/debounce"
export * from "./utils/numbers"
export * from "./utils/tailwindcss"

export * from "./geometries/LightningStrike"
export * from "./geometries/roundedPlaneGeometry"
export * from "./materials"

export * from "./supabase/createClient"

export * from "./const"

export const ubuntuMonoRegular = {
  bmfont: bmfontUbuntuMonoRegular,
  atlas: atlasUbuntuSansMonoRegular,
}

export const ubuntuMonoBold = {
  bmfont: bmfontUbuntuMonoBold,
  atlas: atlasUbuntuMonoBold,
}

export {
  auraExplosion,
  auraExplosionLoop,
  blender,
  fbm,
  guestbookSoundtrack,
  introSoundtrack,
  man,
  MSDFTextGeometry,
  perlin,
  random,
  screaming1,
  screaming2,
  worksPreAura,
}
